import React from "react";
import TopBar from "./TopBar";

const StarsPage = () => {
  return (
    <>
      <TopBar/>
    <div className="min-h-screen flex flex-col items-center bg-heroBg text-astro">
      {/* Hero Section */}
      <section className="w-full text-center py-20">
        <h1 className="text-5xl font-bold">Stars & Market Insights</h1>
        <p className="mt-4 text-lg text-gray-700">Explore the zodiac and financial trends guided by cosmic wisdom.</p>
      </section>

      {/* Zodiac Sign Grid */}
      <section className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl">
        {["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"].map((sign) => (
        <div key={sign} className="p-6 bg-darkGreen text-darkGreen rounded-lg shadow-lg hover:shadow-2xl transition border border-gold">
          <h3 className="text-xl font-semibold">{sign}</h3>
          <p className="text-sm text-darkGreen /80 mt-2">See your trading insights</p>
        </div>
        ))}
      </section>

      {/* Featured Market Insights */}
      <section className="mt-20 text-center max-w-3xl">
        <h2 className="text-4xl font-bold">Featured Market Insights</h2>
        <p className="mt-4 text-gray-700">Stay ahead with the latest financial trends influenced by cosmic patterns.</p>
        <div className="mt-8 p-6 bg-white shadow-lg rounded-lg">
          <h3 className="text-2xl font-semibold text-astro">Astrological Market Forecast</h3>
          <p className="text-gray-600 mt-2">Find out how planetary alignments may impact stocks this week.</p>
        </div>
      </section>
    </div>
  </>
  );
};

export default StarsPage;
